export function getSocialNetworkIconSrc(type: string, socialName: string): string {
    return `./assets/img/websites/social-icons/${type}/${socialName}-${type}.svg`;
}
